import React from 'react';
import { OptionRow } from '../../ui/OptionRow';
import { asDraft } from '../../../types/registration';
import type { QuestionProps } from './types';
export function VisibilityQuestion({
  data,
  update
}: QuestionProps) {
  const draft = asDraft(data);
  return <div className="flex flex-col gap-5" data-id="element-459" data-mp="3cuq7s1e7hfxs">
      <div role="radiogroup" aria-label="Profile visibility" className="flex flex-col gap-2.5" data-id="element-460" data-mp="37yj3ed1gkchy">
        <OptionRow title="Keep me to myself for now" description="Look around, read the archive, see who’s here — without appearing yourself." selected={draft.visibility === 'private'} onSelect={() => update({
        visibility: 'private'
      })} data-id="element-461" data-mp="8iw8k7czb7b5" />
        <OptionRow title="Let other members find me" description="Signed-in members see your first name, last initial, and your years. Nothing else, and nothing on the open web." selected={draft.visibility === 'public'} onSelect={() => update({
        visibility: 'public'
      })} data-id="element-462" data-mp="3qohj9fbhz9w5" />
      </div>

      <ul className="flex list-disc flex-col gap-1.5 border-t border-rule pl-5 pt-4 text-small text-ink-muted" data-id="element-463" data-mp="1a5axnd5iuub8">
        <li data-id="element-464" data-mp="1e51kx6vuasb0">Your surname, email, and phone are never shown either way.</li>
        <li data-id="element-465" data-mp="104qs3yayz3n7">Nothing here is indexed by search engines.</li>
        <li data-id="element-466" data-mp="154wnnpkd1aak">Nothing ranks members or compares how long anyone has been sober.</li>
        <li data-id="element-467" data-mp="156zmmz3hqdrf">You can change this in a single tap, any time.</li>
      </ul>
    </div>;
}